import { keyBy } from 'lodash';
import { ProductSpec } from 'src/graphql';

export const EXTRA_PRODUCT_SPECS: ProductSpec[] = [
  {
    headlineColor: '#0251ff',
    code: 'vhis-standard',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'vhis-flexi-regular',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#37b729',
    code: 'vhis-flexi-plus',
    order: 2,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-1',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-2',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-3',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-4',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-1',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-2',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-3',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-4',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'touch-wood-protector',
    order: 0,
    smoke: false,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-100',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-200',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-300',
    order: 2,
    smoke: true,
    gender: true,
    sumAssured: false,
  },
  {
    headlineColor: '#ff0202',
    code: 'term-life',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: true,
  },
  {
    headlineColor: '#ff0202',
    code: 'term-ci',
    order: 0,
    smoke: true,
    gender: true,
    sumAssured: true,
  },
  {
    headlineColor: '#ff0202',
    code: 'term-ci-plus',
    order: 1,
    smoke: true,
    gender: true,
    sumAssured: true,
  },
];

export const EXTRA_PRODUCT_SPECS_BY_CODE: Record<string, ProductSpec> = keyBy(
  EXTRA_PRODUCT_SPECS,
  'code',
);
